<template>
  <div v-if="frames.length > 1" class="frame-thumbnails">
    <div
      v-for="(frame, index) in frames"
      :key="index"
      class="frame-thumbnails__item"
      :class="{ 'frame-thumbnails__item--selected': index === current }"
      role="button"
      tabindex="0"
      @click="$emit('update:current', index)"
      @keypress.enter="$emit('update:current', index)"
    >
      <div class="frame-thumbnails__thumb">
        <img :src="$path('image.url', frame)" :alt="`${index + 1}`" loading="lazy" decoding="async" />
        <slot name="overlay" :frame="frame" :index="index" />
      </div>
      <slot name="caption" :frame="frame" :index="index" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    frames: {
      type: Array,
      default: () => [],
    },
    current: {
      type: Number,
      default: 0,
    },
  },
}
</script>

<style lang="scss">
.frame-thumbnails {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
  gap: 0.5rem;
  max-height: 320px;
  margin-top: 1rem;
  overflow-y: auto;
  padding: 4px;

  &__item {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.25rem;
    cursor: pointer;

    &--selected .frame-thumbnails__thumb {
      outline: 2px solid var(--primary);
      outline-offset: 2px;
    }
  }

  &__thumb {
    position: relative;
    width: 100%;
    aspect-ratio: 3 / 2;
    border-radius: var(--border-radius-sm);
    overflow: hidden;
    background-color: var(--light-grey);
    content-visibility: auto;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
    }
  }
}
</style>
